import { FontSizeOutlined } from "@ant-design/icons";
import { titleCore } from "./core/title";
import { defineWidget } from "../widgetDefinition";
import { NoSlots } from "../Slots";
import { NoControlPanel, NoDuplication, NoInfo } from "../widgetContract";
import type { TitleComponentSpec } from "../Processing/types";
import { TitleWidget } from "../WidgetComponents/TitleWidget";
import { TitleConfigurator } from "../AddWidgetModal/TitleConfigurator";

export const titleDefinition = defineWidget<TitleComponentSpec>({
  ...titleCore,
  type: "title",
  slots: NoSlots,
  duplicate: NoDuplication,
  controlPanel: NoControlPanel,
  info: NoInfo,
  schema: ["display"],
  contractHash: "1arf3zkqjwn",

  template: {
    label: "Title",
    description: "Section heading or label for dashboard areas",
    icon: <FontSizeOutlined />,
  },

  defaultLayout: { w: 4, h: 2, minW: 2, minH: 1 },

  gridComponent: ({ id }) => <TitleWidget id={id} />,

  configurator: {
    modalTitle: "Title Widget",
    wide: false,
    Component: TitleConfigurator as any,
  },
});
